import {
  Attachment,
  InputValue,
} from '@/checkout-instore-legacy/product/typings'
import { ItemAttachment } from '.'
import { SubmitProps } from './AttachmentForm'

const getEmptyInputValues = (
  inputValues?: InputValue[]
): Record<string, string> => {
  if (!inputValues) {
    return {}
  }

  return inputValues.reduce((accumulator, inputValue) => {
    accumulator[inputValue.label] = ''

    return accumulator
  }, {} as Record<string, string>)
}

export const transformAttachmentsEmptyValues = (
  attachments: Attachment[]
): ItemAttachment[] => {
  return attachments.map((attachment) => {
    const content = getEmptyInputValues(attachment.inputValues)

    return {
      name: attachment.id,
      content,
    }
  })
}

interface FormValueStep {
  step: number
  formValues: SubmitProps
}

export const transformFormsValuesMap = (
  formsValues: Map<number, SubmitProps>
) => {
  return Array.from(formsValues).reduce((accumulator, [step, formValues]) => {
    accumulator[formValues.attachmentId] = { step, formValues }

    return accumulator
  }, {} as Record<string, FormValueStep>)
}
